import React from 'react';
import { string, node, objectOf, bool } from 'prop-types';
import { parse, stringify } from 'query-string';
import { getPIPRules, getBrowseSearchRules, getPackageRules } from './rules';

export function getPathWithMergedParams(redirectPath, queryParams) {
  let parsedQueryParms = parse(queryParams);
  const splitRedirectPath = redirectPath.split('?');
  let path = splitRedirectPath[0];
  if (splitRedirectPath.length >= 2) {
    const redirectPathParams = splitRedirectPath[1];
    const parsedRedirectQueryParms = parse(redirectPathParams);
    Object.assign(parsedQueryParms, parsedRedirectQueryParms);
  }
  return path + '?' + stringify(parsedQueryParms);
}


const Redirector = (props) => {
  const {
    redirectState, bypass, pathWithQueryParams, itemId, keyword, navParam, children, nttKeyword, packageId
  } = props;
  const [path, queryParams] = pathWithQueryParams.split('?');
  let redirectRules = {};

  if (bypass) {
    redirectState.redirect = false;
    return children;
  }

  if (/^\/p\//.test(path)) {
    if (/^\/p\/sets\//.test(path)) {
      redirectRules = getPackageRules({ packageId });
    } else {
      redirectRules = getPIPRules({ path, queryParams, itemId });
    }

  } else if (/^\/s\//.test(path) || /^\/b\//.test(path)) {
    redirectRules = getBrowseSearchRules({ path, queryParams, keyword, navParam, nttKeyword });
  }

  const { shouldRedirect = false, redirectPath = '', httpCode = 200, isErrorStatus = false } = redirectRules;

  if (shouldRedirect || isErrorStatus) {
    const fullRedirectPath = queryParams ? `${getPathWithMergedParams(redirectPath, queryParams)}` : redirectPath;
    redirectState.redirect = shouldRedirect;
    redirectState.url = fullRedirectPath;
    redirectState.code = httpCode;
    redirectState.isErrorStatus = isErrorStatus;
    return null;
  }
  if (redirectRules.loading) return null;

  return children;
};

Redirector.propTypes = {
  pathWithQueryParams: string.isRequired,
  redirectState: objectOf(bool).isRequired,
  children: node,
  itemId: string,
  keyword: string,
  navParam: string,
  bypass: bool,
};

Redirector.defaultProps = {
  children: null,
  itemId: null,
  keyword: null,
  navParam: null,
  bypass: false,
};

export { Redirector };
